import { useContext, useState } from "react";
import UserProfile from "../../../UiLibrary/UserProfile";
import KeyCloackService from "../../../../services/KeyCloackService";
import { Link } from "react-router-dom";
import TeamService from "../../../../services/TeamService";
import { toast } from "react-toastify";
import Modal from "../../../UiLibrary/Modal";
import { UserContext } from "../../../Context/UserContext";
import IBrand from "../../../Interfaces/Brand";
import { useTranslation } from "react-i18next";

type Props = {
  brand: IBrand | undefined;
  setBrand: (brand: IBrand) => void;
  doLogin: () => void;
};

const MembersTab = (props: Props) => {
  const { brand } = props;
  const { t } = useTranslation()
  const { user } = useContext(UserContext);
  const [showRemoveModal, setShowRemoveModal] = useState<{
    show: boolean;
    playerId?: string | undefined;
  }>({ show: false, playerId: undefined });
  const [loading, setloading] = useState(false);

  const removeMember = () => {
    if (!brand || !showRemoveModal.playerId) {
      return;
    }
    setloading(true);
    const membersId = [showRemoveModal.playerId];
    TeamService.removeMemberFromBrand(brand.slug, membersId)
      .then((Rbrand) => {
        toast.success(t('toast.memberRemovedSuccess'));
        props.setBrand(Rbrand);
        setloading(false);
        setShowRemoveModal({ show: false });
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
        setShowRemoveModal({ show: false });
        setloading(false);
      });
  };

  return (
    <div className="players-tab container tab-with-table">
      {brand && brand.members?.length > 0 && (
        <div className="columns">
          <div className="column col-12">
            <div className="space-divider-20"></div>
            <dl>
              {brand?.members &&
                brand?.members.map((playerId) => (
                  <dd
                    key={playerId}
                    className="columns flex-centered show-on-hover"
                  >
                    <div className="column col-8">
                      <Link to={`/users/${playerId}/overview`}>
                        <UserProfile userId={playerId}>
                          {(brand?.owner === playerId || brand?.admins?.includes(playerId) ) && (
                            <span className="skp-chip status-captain skp-text-xxsmall">
                              {t('common.admin')}
                            </span>
                          )}
                        </UserProfile>
                      </Link>
                    </div>
                    <div className="column col-4 text-right">
                      {user?.id === brand?.owner && brand?.owner !== playerId && (
                        <button
                          className="skp-btn skp-btn-alert"
                          onClick={() =>
                            setShowRemoveModal({
                              show: true,
                              playerId: playerId,
                            })
                          }
                        >
                          {t('common.remove')}
                        </button>
                      )}
                    </div>
                  </dd>
                ))}
            </dl>
          </div>
          <div className="space-divider-40"></div>
          {/* Login button */}
          {!KeyCloackService.isLoggedIn() && (
            <div className="column col-12 text-center">
              <div className="skp-text-light">
                {t('players.mustLogin')}
              </div>
              <div className="space-divider-20"></div>
              <button
                className="skp-btn skp-btn-primary"
                onClick={props.doLogin}
              >
                {t('common.login')}
              </button>
            </div>
          )}
        </div>
      )}
      {brand?.members?.length === 0 && (
        <div className="columns skp-text-light text-center">
          <div className="space-divider"></div>
          <div className="column col-12">
            <h1>
              <i className="las la-user-friends"></i>
            </h1>
          </div>
          <div className="column col-12">
            <h5>{t('players.noPlayers')}</h5>
          </div>
          <div className="column col-12">
            {t('brands.members.noPlayerRegistered')}
          </div>
        </div>
      )}

      <Modal
        show={showRemoveModal.show}
        onClose={() => setShowRemoveModal({ show: false })}
        onConfirm={() => removeMember()}
        confirmation={t('brands.members.removePlayer')}
        title={t('brands.members.removePlayer')}
        size="small"
        loading={loading}
      >
        <>
          <div className="space-divider-20"></div>
          <div className="skp-text-primary text-center">
            {t('brands.members.doRemovePlayer')}
          </div>
          <div className="space-divider-20"></div>
        </>
      </Modal>
    </div>
  );
};

export default MembersTab;
